import { mutator } from 'satcheljs';
import {
    type SET_LOADING_STATE_FOR_FOLDER_TREEActionMessage,
    setLoadingStateForFolderTree,
} from '../actions/setLoadingStateForFolderTree';
import getMailboxFolderTreeDataTable from '../selectors/getMailboxFolderTreeDataTable';

/**
 * Mutator that sets the loading state for folder tree.
 */
const defaultExport: (actionMessage: SET_LOADING_STATE_FOR_FOLDER_TREEActionMessage) => void =
    /* eslint-disable-next-line owa-custom-rules/prefer-mutator-action -- (https://aka.ms/OWALintWiki)
     * Baseline. DO NOT COPY AND PASTE!
     *	> Please use a mutatorAction if action is defined in the same package */
    mutator(setLoadingStateForFolderTree, actionMessage => {
        const { folderTreeId, mailboxInfo } = actionMessage;
        const folderTree = getMailboxFolderTreeDataTable(mailboxInfo)?.get(folderTreeId);
        if (folderTree) {
            folderTree.loadingState = actionMessage.loadingState;
        }
    });
export default defaultExport;
